import {
  Box,
  Button,
  IconButton,
  HStack,
  Image,
  Link,
} from "@chakra-ui/react";
import { FaTwitter, FaMediumM, FaDiscord } from "react-icons/fa";
import { AiFillYoutube } from "react-icons/ai";
import { ReactElement } from "react";

export default function NavBar() {

  const NavItem = ({ href, icon }: { href: string; icon: ReactElement }) => {
    return (
      <Link href={href}>
        <IconButton aria-label="icon1" variant={"ghost"} icon={icon} />
      </Link>
    );
  };

  return (
    <Box bg="gray.900" px={4} minW="full">
      <Box
        display="flex"
        flexDir="row"
        py={['10px', "20px"]}
        px={['5px',"30px"]}
        height={['60px', "80px"]}
        alignItems="center"
        justifyContent="space-between"
      >
        <Image 
          src= {'/logo.png'} 
          width={['120px','180px']} 
          ml='10px' 
          alt='logo'
          cursor='pointer'
          onClick={() => window.location.href = 'https://www.mesprotocol.com/'}
          />
        <HStack spacing={8}>
          <HStack display={{base: 'none', lg: 'block'}}>
            <NavItem href="https://discord.gg/dxxyDwWasH" icon={<FaDiscord/>}/>
            <NavItem href="https://twitter.com/MESprotocol" icon={<FaTwitter/>}/>
            <NavItem href="https://medium.com/@mesprotocol" icon={<FaMediumM/>}/>
            <NavItem href="https://www.youtube.com/channel/UC359_LX0FUD7cm-2Qnfrw0Q" icon={<AiFillYoutube/>}/>
          </HStack>
          <Button colorScheme={'facebook'} fontSize={13} onClick={() => window.location.href = 'https://app.mesprotocol.com/'}>
            Launch App
          </Button>
        </HStack>
      </Box>
    </Box>
  );
}
